import { Component, OnInit } from '@angular/core';
import {
  AllowedCountryType,
  BaseCssProperties,
  ProviderClass,
  UiZoneWidgetAttributeConfig,
  UiZoneWidgetConfig,
  baseCssConfigStyle,
} from '@finxone-platform/shared/sys-config-types';

import { UpdateFormDataActionWithId } from '@app/finxone-web-frontend/app/lib/actions/form-submission.action';
import { Country } from '@app/finxone-web-frontend/app/lib/dtos/countries.dto';
import { Currency } from '@app/finxone-web-frontend/app/lib/dtos/currencies.dto';
import { ConfigService } from '@app/finxone-web-frontend/app/lib/services/config-service/config-service.service';
import { AccountState } from '@app/finxone-web-frontend/app/lib/state/account.state';
import {
  countryCodeToCircleFlag,
  currencyToCircleFlag,
} from '@app/finxone-web-frontend/app/lib/utils/template/handlebar-helpers/currency-to-flag.utils';
import {
  removeDuplicateCurrencies,
  removeInvalidCurrencies,
} from '@app/finxone-web-frontend/app/lib/utils/utils';
import { FormActionTypeEnum } from '@finxone-platform/form-action';
import { AutoDestroy } from '@finxone-platform/shared/base-types';
import { Store } from '@ngxs/store';
import { Subject, map, takeUntil } from 'rxjs';
import { BaseComponent } from '../../../base/base.component';
@Component({
  standalone: false,
  selector: 'finxone-web-frontend-edit-beneficiary-intl-currency-country-new-widget',
  templateUrl: './edit-beneficiary-intl-currency-country-new-widget.component.html',
})
export class EditBeneficiaryIntlCurrencyCountryNewWidgetComponent extends BaseComponent implements OnInit {
  @AutoDestroy destroy$: Subject<void> = new Subject<void>();
  countryList: AllowedCountryType[];
  public currencies: Currency[];
  public currenciesCodes: {
    title: string;
    currencyFlag: string;
    value: string;
  }[] = [];
  public widgetConfig: UiZoneWidgetConfig;
  public countries: Country[];
  public currentActiveStyle: baseCssConfigStyle;
  public continueButtonStyle: baseCssConfigStyle = {};
  public continueButtonContent = 'Continue';
  public supportedCurrencies: string[];
  public showCurrencyFlags = true;
  constructor(
    public dataIn: ProviderClass<UiZoneWidgetAttributeConfig>,
    private configService: ConfigService,
    private store: Store,
  ) {
    super();
    this.store
      .selectOnce(AccountState.getPaymentGatewayConfig)
      .pipe(
        map((paymentGatewayConfig) => {
          this.supportedCurrencies = paymentGatewayConfig.supportedCurrency ?? ['GBP', 'USD', 'EUR'];
        }),
      )
      .subscribe();

    this.configService
      .getCurrencies()
      .pipe(
        takeUntil(this.destroy$),
        map((response) => {
          const validCurrencies = removeInvalidCurrencies(response);
          this.currencies = removeDuplicateCurrencies(validCurrencies, 'currency_code');
          this.currencies = this.currencies.filter((currency) =>
            this.supportedCurrencies.includes(currency.currency_code),
          );
          this.currenciesCodes = this.currencies.map(({ currency_code }) => ({
            title: currency_code,
            currencyFlag: currencyToCircleFlag(currency_code, '24px'),
            value: currency_code,
          }));
        }),
      )
      .subscribe();
  }
  ngOnInit() {
    if (this.dataIn != undefined && this.dataIn != null) {
      this.widgetConfig = this.dataIn.widgetConfig;
      this.attri = this.dataIn.attri;
    }

    this.contentStyle = this.configService.getSpecificBaseCssStyle(this.attri, [
      BaseCssProperties.PADDING,
      BaseCssProperties.BACKGROUND_COLOR,
      BaseCssProperties.MARGIN,
      BaseCssProperties.BORDER,
      BaseCssProperties.BOX_SHADOW,
      BaseCssProperties.COLOR,
      BaseCssProperties.FONT_SIZE,
    ]);

    this.getAllCountriesForList();

    this.showCurrencyFlags = this.attri?.widgetProperties?.showFlag ?? true;
  }

  private getAllCountriesForList() {
    this.configService
      .getCountries()
      .pipe(
        takeUntil(this.destroy$),
        map((response) => {
          this.countries = response;
          this.countryList = this.countries.map(({ name, code }) => ({
            title: name,
            currencyFlag: countryCodeToCircleFlag(code, '24px'),
            key: code,
          }));
        }),
      )
      .subscribe();
  }

  public updateFormActionState(event: {
    currency: string;
    countryIso2: string;
    isCountryCurrencyFormValid: boolean;
  }) {
    this.store.dispatch(new UpdateFormDataActionWithId(event, FormActionTypeEnum.INTL_BENEFICIARY_ADD));
  }
}
